module.exports = require("@wildboar/x500/src/lib/modules/InformationFramework/id-sc-pwdAdminSubentry.va");